export default {
  animal: {
    size: {
      enum: {
        TOY: 'toy',
        SMALL: 'small',
        MEDIUM: 'medium',
        BIG: 'big',
        GIANT: 'giant',
      },
      translations: {
        toy: 'Toy',
        small: 'Pequeno',
        medium: 'Médio',
        big: 'Grande',
        giant: 'Gigante',
      },
    },
    gender: {
      enum: {
        MALE: 'male',
        FEMALE: 'female',
      },
      translations: {
        male: 'Macho',
        female: 'Fêmea',
      },
    },
  },
  animalFair: {
    behaviorCharacteristics: {
      enum: {
        ACTIVE: 'active',
        AGGRESSIVE: 'aggressive',
        PLAYFUL: 'playful',
        CALM: 'calm',
        AFFECTIONATE: 'affectionate',
        DOCILE: 'docile',
        FEARFUL: 'fearful',
        NEEDS_ADAPTATION: 'needsAdaptation',
        GOOD_WITH_DOGS: 'goodWithDogs',
        GOOD_WITH_CHILDREN: 'goodWithChildren',
        GOOD_WITH_CATS: 'goodWithCats',
        TERRITORIAL: 'territorial',
        SHY: 'shy',
      },
      translations: {
        active: 'Ativo',
        aggressive: 'Bravo',
        playful: 'Brincalhão',
        calm: 'Calmo',
        affectionate: 'Carinhoso',
        docile: 'Dócil',
        fearful: 'Medroso',
        needsAdaptation: 'Precisa de adaptação',
        goodWithDogs: 'Se dá bem com cães',
        goodWithChildren: 'Se dá bem com crianças',
        goodWithCats: 'Se dá bem com gatos',
        territorial: 'Territorial',
        shy: 'Tímido',
      },
    },
    healthConditions: {
      enum: {
        UNDER_TREATMENT: 'underTreatment',
        SENIOR: 'senior',
        SPECIAL_CARE: 'specialCare',
        REQUIRES_CONTINUOUS_MEDICATION: 'requiresContinuousMedication',
        HEARING_DISABILITY: 'hearingDisability',
        PHYSICAL_DISABILITY: 'physicalDisability',
        VISUAL_DISABILITY: 'visualDisability',
        CHRONIC_DISEASE: 'chronicDisease',
        HEALTHY: 'healthy',
      },
      translations: {
        underTreatment: 'Em tratamento',
        senior: 'Idoso',
        specialCare: 'Necessita cuidados especiais',
        requiresContinuousMedication: 'Necessita medicação contínua',
        hearingDisability: 'Possui deficiência auditiva',
        physicalDisability: 'Possui deficiência física',
        visualDisability: 'Possui deficiência visual',
        chronicDisease: 'Possui doença crônica',
        healthy: 'Saudável',
      },
    },
  },
  adoption: {
    status: {
      enum: {
        REQUESTED: 'requested',
        CONFIRMED: 'confirmed',
        REJECTED: 'rejected',
        CANCELED: 'canceled',
      },
      translations: {
        requested: 'Solicitada',
        confirmed: 'Confirmada',
        rejected: 'Rejeitada',
        canceled: 'Cancelada',
      },
    },
  },
  licensing: {
    type: {
      enum: {
        CASTRATOR: 'castrator',
        ROTECTOR: 'protector',
        CHIPS_APPLYER: 'chipsApplyer',
        NGO: 'ngo',
      },
      translations: {
        castrator: 'Castrador',
        protector: 'Protetor',
        chipsApplyer: 'Aplicador de Chip',
        ngo: 'ONG',
      },
    },
    status: {
      enum: {
        REQUESTED: 'requested',
        APPROVED: 'approved',
        REJECTED: 'rejected',
        REVOKED: 'revoked',
      },
      translations: {
        requested: 'Solicitado',
        approved: 'Aprovado',
        rejected: 'Rejeitado',
        revoked: 'Revogado',
      },
    },
  },
  castration: {
    status: {
      enum: {
        REQUESTED: 'requested',
        REJECTED: 'rejected',
        CANCELED: 'canceled',
        PRE_APPROVED: 'preApproved',
        APPROVED: 'approved',
        REVISION: 'revision',
        SCHEDULED: 'scheduled',
        ATTENDANCE: 'attendance',
        IN_TREATMENT: 'inTreatment',
        CORRECTED: 'corrected',
        CORRECTION: 'correction',
        AWAITING_CONFIRMATION: 'awaitingConfirmation',
        COMPLETED: 'completed',
      },
      translations: {
        requested: 'Solicitada',
        rejected: 'Rejeitada',
        canceled: 'Cancelada',
        inTreatment: 'Em tratamento',
        preApproved: 'Pré aprovada',
        approved: 'Aprovada',
        revision: 'Em vistoria',
        scheduled: 'Agendada',
        correction: 'Correção',
        corrected: 'Corrigida pelo tutor',
        attendance: 'Em atendimento',
        awaitingConfirmation: 'Aguardando confirmar',
        completed: 'Concluída',
      },
    },
  },
  mistreatment: {
    status: {
      enum: {
        OPENED: 'opened',
        CHECKING: 'checking',
        DONE: 'done',
        REJECTED: 'rejected',
        CANCELED: 'canceled',
        AWAITING_CONCLUSION: 'awaitingConclusion',
        ALL: 'all',
      },
      translations: {
        opened: 'Aberto',
        checking: 'Em verificação',
        done: 'Pronto',
        rejected: 'Rejeitado',
        canceled: 'Cancelado',
        awaitingConclusion: 'Aguardando conclusão',
        all: 'Todos os status',
      },
    },
    result: {
      enum: {
        AWAITING: 'awaiting',
        MEASURES_APPLIED: 'measuresApplied',
        UNFOUNDED: 'unfounded',
        CANCELED: 'canceled',
      },
      translations: {
        awaiting: 'Aguardando',
        measuresApplied: 'Medidas legais aplicadas',
        unfounded: 'Não aplicável',
        canceled: 'Cancelado',
      },
    },
  },
  complaint: {
    type: {
      enum: {
        INAPPROPRIATE_CONTENT: 'inappropriateContent',
        VIOLENCE: 'violence',
        IS_NOT_A_PET: 'isNotAPet',
        FRAUD: 'fraud',
        OTHER: 'other',
      },
      translations: {
        inappropriateContent: 'Conteúdo inapropriado',
        violence: 'Violência',
        isNotAPet: 'Não é um animal',
        fraud: 'Fraude',
        other: 'Outra',
      },
    },
  },
  castrationCorrectionRequired: {
    type: {
      enum: {
        ADDRESS_REQUIRED: 'addressRequired',
        PHOTO_REQUIRED: 'photoRequired',
        SELFIE_REQUIRED: 'selfieRequired',
        OTHER: 'other',
      },
      translations: {
        addressRequired: 'Endereço',
        photoRequired: 'Foto',
        selfieRequired: 'Selfie com documento',
        other: 'Outras correções',
      },
    },
  },
  clinicalCareCorrectionRequired: {
    type: {
      enum: {
        ADDRESS_REQUIRED: 'addressRequired',
        PHOTO_REQUIRED: 'photoRequired',
        SELFIE_REQUIRED: 'selfieRequired',
        LOW_INCOME_ATTACHMENTS_REQUIRED: 'lowIncomeAttachmentsRequired',
        OTHER: 'other',
      },
      translations: {
        addressRequired: 'Endereço onde o pet vive/está',
        photoRequired: 'Foto do pet',
        selfieRequired: 'Selfie com documento',
        lowIncomeAttachmentsRequired: 'Comprovantes de baixa renda',
        other: 'Outras correções',
      },
    },
  },
  region: {
    type: {
      enum: {
        ZONE: 'zone',
        NEIGHBORHOOD: 'neighborhood',
        STREET: 'street',
        CITY: 'city',
        CUSTOM: 'custom',
      },
      translations: {
        zone: 'Zona',
        neighborhood: 'Bairro',
        street: 'Rua',
        city: 'Cidade',
        custom: 'Região customizada',
      },
    },
  },
}
